import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {LoginService} from "@app/login/login.service";
import {MatDialog, MatDialogConfig, MatDialogRef} from "@angular/material/dialog";
import {NewsSortComponent} from "@app/pages/news/sort/news-sort.component";
import {NewsService} from "@app/services/news/news.service";
import {EditArticleComponent} from "@app/pages/news/edit-article/edit-article.component";

@Component({
    selector: 'flex-news',
    templateUrl: './news.component.html',
    styleUrls: ['./news.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class NewsComponent implements OnInit{
    //use to create and display the dialogs
    dialogRef: MatDialogRef<any>;
    dialogConfig = new MatDialogConfig();


    constructor(public loginService: LoginService, public dialog: MatDialog, public newsService: NewsService) {
    }

    ngOnInit(): void {
        //logic offloaded and handled by service so sync data between parent and children
        this.newsService.loadNews();
    }
    //opens sort dialog
    sort() {
        this.dialogConfig.width = 'auto';
        this.dialogConfig.height = 'auto';
        this.dialogRef = this.dialog.open(NewsSortComponent, this.dialogConfig);
    }
    //opens add dialog
    add(){
        this.dialogConfig.data = {data: {isNew: true}, ref: this.dialogConfig}
        this.dialogConfig.width = '800px';
        this.dialogConfig.height = '800px';
        this.dialogRef = this.dialog.open(EditArticleComponent, this.dialogConfig);
    }
}

